import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M7.8 4.3 4.7 1.2c-.4-.4-1-.4-1.4 0L.2 4.3c-.2.2-.3.5-.1.7s.5.2.7 0l2.7-2.6v12.5c0 .3.2.5.5.5s.5-.2.5-.5V2.4L7.2 5c.2.2.5.2.7 0 .1-.2.1-.5-.1-.7q.15 0 0 0m8.1 6.7c-.2-.2-.5-.2-.7 0l-2.7 2.6V1.2c0-.3-.2-.5-.5-.5s-.5.2-.5.5v12.5L8.9 11c-.2-.2-.5-.2-.7 0s-.2.5 0 .7l3.1 3.2c.4.4 1 .4 1.4 0l3.1-3.1c.2-.3.2-.6.1-.8q-.15 0 0 0" />
  </svg>
);
const SvgArrowsDouble = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="arrows-double" {...props} />;
export default SvgArrowsDouble;
